"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const R = __importStar(require("ramda"));
const react_apollo_1 = require("react-apollo");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const auth_1 = require("@8base-react/auth");
const apollo_client_1 = require("@8base/apollo-client");
const FragmentsSchemaContainer_1 = require("./FragmentsSchemaContainer");
const ApolloContainer = auth_1.withAuth((_a = class ApolloContainer extends react_1.default.Component {
        constructor() {
            super(...arguments);
            this.createClient = R.memoizeWith(R.identity, introspectionQueryResultData => {
                const { withAuth, withSubscriptions, autoSignUp, authProfileId, cacheOptions, } = this.props;
                const commonOptions = {
                    cache: introspectionQueryResultData
                        ? new apollo_cache_inmemory_1.InMemoryCache(Object.assign(Object.assign({}, cacheOptions), { fragmentMatcher: new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
                                introspectionQueryResultData,
                            }) }))
                        : new apollo_cache_inmemory_1.InMemoryCache(cacheOptions),
                    extendLinks: this.props.extendLinks,
                    onRequestError: this.props.onRequestError,
                    onRequestSuccess: this.props.onRequestSuccess,
                    uri: this.props.uri,
                    subscriptionUri: this.props.subscriptionUri,
                    withSubscriptions,
                };
                const apolloClientOptions = withAuth
                    ? Object.assign(Object.assign({}, commonOptions), { authProfileId,
                        autoSignUp, getAuthState: this.getAuthState, onAuthError: this.onAuthError, onIdTokenExpired: this.onIdTokenExpired, withAuth: true }) : Object.assign(Object.assign({}, commonOptions), { withAuth: false });
                return new apollo_client_1.ApolloClient(apolloClientOptions);
            });
            this.onIdTokenExpired = () => __awaiter(this, void 0, void 0, function* () {
                const { auth: { authClient }, } = this.props;
                const { idToken } = yield authClient.checkSession({});
                authClient.setState({ token: idToken });
            });
            this.onAuthError = () => __awaiter(this, void 0, void 0, function* () {
                const { auth: { authClient }, } = this.props;
                yield this.client.clearStore();
                authClient.batch(() => {
                    authClient.purgeState();
                    authClient.logout();
                });
            });
            this.getAuthState = () => {
                const { auth: { authState }, } = this.props;
                return authState;
            };
            this.renderContent = ({ loading, introspectionQueryResultData, }) => {
                if (loading) {
                    return null;
                }
                this.client = this.createClient(introspectionQueryResultData);
                return (react_1.default.createElement(react_apollo_1.ApolloProvider, { client: this.client }, this.props.children));
            };
        }
        render() {
            const { uri, introspectionQueryResultData } = this.props;
            if (introspectionQueryResultData !== undefined) {
                return this.renderContent({
                    loading: false,
                    introspectionQueryResultData,
                });
            }
            return (react_1.default.createElement(FragmentsSchemaContainer_1.FragmentsSchemaContainer, { uri: uri }, this.renderContent));
        }
    },
    _a.defaultProps = {
        autoSignUp: false,
        withAuth: true,
        withSubscriptions: false,
        cacheOptions: {},
    },
    _a));
exports.ApolloContainer = ApolloContainer;
//# sourceMappingURL=ApolloContainer.js.map